import { SB } from '@play-co/replicant';

export const levelSchema = {
  level: SB.object({
    // Current player XP. Once this reaches the required XP to level up, it will be reset to 0.
    xp: SB.int(),
    // Current player level. Range: [0-99[
    current: SB.int(),
    // Last level a reward was claimed.
    lastLevelReward: SB.int(),
  }),
};
